/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import { FilterGroupingOperation } from '../enums';

import type { GroupingExpression, PredicateExpression } from '../interfaces';

export function toGroupingExpression(
    items: PredicateExpression[],
    operation: FilterGroupingOperation = FilterGroupingOperation.Or,
): GroupingExpression {
    return {
        items,
        operation,
    };
}

